import gql from 'graphql-tag';

export default gql`
  query JobInfo(
    $advertiserId: String!
    $jobId: String!
    $language: LanguageCodeIso
  ) {
    getJobDetails(
      advertiserId: $advertiserId
      jobId: $jobId
      language: $language
    ) {
      id
      status
      postChannel
      title
      adType
      productDisplayName
      billableApplicants {
        ... on BillableApplicantsResponseSuccess {
          data {
            count
          }
        }
        ... on ResponseError {
          error
        }
      }
      workType
      minSalary
      maxSalary
      salaryCurrency
      payType
      salaryText
      categoryName
      subCategoryName
      categoryId
      locations {
        id
        description
        country
        type
        parent {
          id
          parent {
            id
            parent {
              id
            }
          }
        }
      }
      advertiserJobReference
      performanceRating {
        status
      }
      createdDate
      canBeUpgraded
      canShowHomeLocationFilterInCandidateManagement
    }
  }
`;
